import { CMS_PREFIX_LIST } from "./cmsPrefix";

const mapToCopyFileShared = (copy: Record<string, string>) => {
  const getCopyValue = (key: string) => copy?.[`${CMS_PREFIX_LIST.shared}/${key}`] ?? "";

  return {
    shared: {
      login: getCopyValue(`login`),
      supportEmail: getCopyValue(`support-email`),
      maintenanceBanner: {
        title: getCopyValue(`maintenance-banner/title`),
        description: getCopyValue(`maintenance-banner/sub-text`),
      },
      maintenancePage: getCopyValue(`maintenance-page/maintenances`),
      locale: {
        "en-CH": getCopyValue(`locale/en-ch`),
        de: getCopyValue(`locale/de`),
        fr: getCopyValue(`locale/fr`),
        it: getCopyValue(`locale/it`),
      },
      faqUrl: getCopyValue(`faq-url`),
      downloadDesktopAppUrl: getCopyValue(`download-desktop-app-url`),
      equipment: {
        noEquipment: getCopyValue(`equipment/no-equipment`),
        mat: getCopyValue(`equipment/mat`),
        chair: getCopyValue(`equipment/chair`),
        cushion: getCopyValue(`equipment/cushion`),
        towel: getCopyValue(`equipment/towel`),
        "2-chairs": getCopyValue(`equipment/2-chairs`),
        "resistance-band": getCopyValue(`equipment/resistance-band`),
        "2-bottles": getCopyValue(`equipment/2-bottles`),
        lighttheraband: getCopyValue(`equipment/lighttheraband`),
        mediumtheraband: getCopyValue(`equipment/mediumtheraband`),
        heavytheraband: getCopyValue(`equipment/heavytheraband`),
      },
      feedback: {
        reactions: getCopyValue(`feedback/reactions`),
        feedbackSent: getCopyValue(`feedback/feedback-sent`),
        thankYou: getCopyValue(`feedback/thank-you`),
        helpful: getCopyValue(`feedback/helpful`),
        like: getCopyValue(`feedback/like`),
        sessionNoHeader: getCopyValue(`feedback/session-no-header`),
        exercisesNo: getCopyValue(`feedback/exercises-no`),
        weekNo: getCopyValue(`feedback/week-no`),
        title: getCopyValue(`feedback/title`),
        subtitle: getCopyValue(`feedback/subtitle`),
        difficultTag: getCopyValue(`feedback/difficult-tag`),
        highPainLevelTag: getCopyValue(`feedback/high-painlevel`),
        noMistakesDetected: {
          title: getCopyValue(`feedback/no-mistakes-detected/title`),
          subtext: getCopyValue(`feedback/no-mistakes-detected/sub-text`),
        },
        completionTooLow: {
          title: getCopyValue(`feedback/completion-too-low/title`),
          subtext: getCopyValue(`feedback/completion-too-low/sub-text`),
        },
        watchPatientAnimation: getCopyValue(`feedback/watch-patient-animation`),
        exerciseCompletion: getCopyValue(`feedback/exercise-completion`),
        sessionCompletion: getCopyValue(`feedback/session-completion`),
        movementQuality: getCopyValue(`feedback/movement-quality`),
        trackingInterruptionLabel: getCopyValue(`feedback/tracking-interruption-label`),
        noAnimationAvailableMessage: getCopyValue(`feedback/no-animation-available-message`),
        painLevel: getCopyValue(`feedback/pain-level`),
        mistakesCard: {
          distributions: {
            left: getCopyValue(`feedback/mistakes-card/distributions/left`),
            right: getCopyValue(`feedback/mistakes-card/distributions/right`),
            symmetric: getCopyValue(`feedback/mistakes-card/distributions/symmetric`),
          },
          n1OutOfN2: getCopyValue(`feedback/mistakes-card/n1-out-of-n2`),
          seconds: getCopyValue(`feedback/mistakes-card/seconds`),
          detectedInReps: getCopyValue(`feedback/mistakes-card/detected-in-reps`),
          qualityReductionLabel: getCopyValue(`feedback/mistakes-card/quality-reduction-label`),
          rightSideButton: getCopyValue(`feedback/mistakes-card/right-side-button`),
          leftSideButton: getCopyValue(`feedback/mistakes-card/left-side-button`),
          bothSidesButton: getCopyValue(`feedback/mistakes-card/both-sides-button`),
        },
        lateralityAbbreviation: {
          left: getCopyValue(`feedback/left-abbreviation`),
          right: getCopyValue(`feedback/right-abbreviation`),
        },
      },
      buttons: {
        download: getCopyValue(`buttons/download`),
        contactSupport: getCopyValue(`buttons/contact-support`),
      },
      pages: {
        offline: {
          statusBanner: getCopyValue("pages/offline/status-banner"),
          title: getCopyValue("pages/offline/title"),
          description: getCopyValue("pages/offline/description"),
        },
      },
      components: {},
      toasts: {},
      dialogs: {
        helpAndSupport: {
          header: {
            title: getCopyValue("dialogs/help-and-support/header/title"),
            subtext: getCopyValue("dialogs/help-and-support/header/sub-text"),
          },
          phoneOption: {
            title: getCopyValue("dialogs/help-and-support/phone-option/title"),
            subtext: getCopyValue("dialogs/help-and-support/phone-option/sub-text"),
          },
          emailOption: {
            title: getCopyValue("dialogs/help-and-support/email-option/title"),
            subtext: getCopyValue("dialogs/help-and-support/email-option/sub-text"),
          },
          sendMessage: getCopyValue("dialogs/help-and-support/send-message"),
          successfullyCopiedToaster: getCopyValue("dialogs/help-and-support/successfully-copied-toaster"),
        },
        useOnDesktopDialog: {
          title: getCopyValue("dialogs/use-on-desktop-dialog/title"),
          subtitle: getCopyValue("dialogs/use-on-desktop-dialog/subtitle"),
        },
        happinessFeedback: {
          submitButton: getCopyValue("dialogs/happiness-feedback/submit-button"),
          ratings: {
            veryPoor: getCopyValue("dialogs/happiness-feedback/ratings/very-poor"),
            poor: getCopyValue("dialogs/happiness-feedback/ratings/poor"),
            acceptable: getCopyValue("dialogs/happiness-feedback/ratings/acceptable"),
            good: getCopyValue("dialogs/happiness-feedback/ratings/good"),
            veryGood: getCopyValue("dialogs/happiness-feedback/ratings/very-good"),
          },
        },
      },
    },
  };
};

export { mapToCopyFileShared };
